<template>
    <div>
        <div class="relative px-4 lg:px-6">
            <div class="absolute inset-s-8 inset-bs-0 w-px h-full bg-slate-300 lg:inset-s-16"></div>

            <template v-for="(filter, filterIndex) in group.filters"
                :key="filter.id">
                <segment-step-form-filter v-model="group.filters[filterIndex]"
                    :isFirst="filterIndex === 0"
                    :localProfileDescription="props.localProfileDescription"
                    @removeFilter="removeFilter(filterIndex)" />
            </template>


            <div class="flex items-center gap-4">
                <vx-box class="relative p-3 inline-flex space-x-2">
                    <vx-button @click="createFilter"
                               type="button"
                               size="lg"
                               color="primary"
                               data-test="create-filter">
                        And <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </vx-button>
                    <vx-button v-if="props.isLast"
                               @click="emit('createGroup')"
                               type="button"
                               size="lg"
                               color="info"
                               data-test="create-group">
                        Or <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
                    </vx-button>
                </vx-box>
                <div v-if="displayFirstError(validate.filters)" class="text-xs text-rose-800">
                    {{ displayFirstError(validate.filters) }}
                </div>
            </div>
        </div>

        <div v-if="!props.isLast"
            class="relative flex p-8">
            <div
                class="absolute inset-s-0 inset-bs-1/2 -translate-y-1/2 w-full h-px border-solid border-y border-x-0 border-t-slate-300 border-b-white">
            </div>
            <div class="relative inline-block border border-solid border-slate-300 rounded-full overflow-hidden"
                style="filter: drop-shadow(0px 1px 0px #FFFFFF);">
                <div
                    class="bg-amber-50 rounded-full overflow-hidden border-t border-solid border-white border-b-0 border-x-0 text-base font-extrabold py-2 px-6">
                    Or
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { VxButton, VxBox } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SegmentStepFormFilter from './SegmentStepFormFilter.vue';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { makeFilter } from './segmentFiltersHelpers';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import { helpers, maxLength } from '@vuelidate/validators';

const group = defineModel({
    type: Object,
    required: true,
})
const props = defineProps({
    isLast: {
        type: Boolean,
        required: false,
    },
    localProfileDescription: String,
})

const emit = defineEmits(['createGroup', 'removeGroup']);

const validate = useVuelidate({
    filters: {
        maxLength: helpers.withMessage('Filter Group should not contain more than 25 filters', maxLength(25)),
    }
}, group);

const createFilter = () => {
    group.value.filters = [...group.value.filters, makeFilter()];
}

const removeFilter = (filterIndex) => {
    if (group.value.filters.length === 1) {
        emit('removeGroup')
        return;
    }

    group.value.filters = group.value.filters.filter((filter, currentIndex) => currentIndex !== filterIndex)
};
</script>
